import { Link } from 'react-router-dom';
import { featuredArticles } from '@/mocks/home';

export default function FeaturedArticles() {
  const featured = featuredArticles.filter((a) => a.featured);
  const regular = featuredArticles.filter((a) => !a.featured);

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-50 text-accent-700 text-xs font-medium mb-3">
              热门文章
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              精选深度好文
            </h2>
          </div>
          <Link
            to="/category/news"
            className="hidden sm:flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
          {featured.slice(0, 2).map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group relative overflow-hidden rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="aspect-[16/9] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-2 text-xs text-foreground-500">
                  <span className="px-2 py-0.5 rounded-full bg-accent-50 text-accent-700 font-medium">{article.category}</span>
                  <span>{article.date}</span>
                  <span>{article.readTime}</span>
                </div>
                <h3 className="font-heading text-lg font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors mb-2 line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-2 mt-3 text-xs text-foreground-500">
                  <div className="w-6 h-6 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 font-medium">
                    {article.author.charAt(0)}
                  </div>
                  <span>{article.author}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {regular.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group relative overflow-hidden rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2 text-xs text-foreground-500">
                  <span className="px-2 py-0.5 rounded-full bg-accent-50 text-accent-700 font-medium">{article.category}</span>
                  <span>{article.date}</span>
                </div>
                <h4 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h4>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/news"
            className="inline-flex items-center gap-1.5 text-sm text-primary-600 font-medium whitespace-nowrap cursor-pointer"
          >
            查看全部文章 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}